import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const JobBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/job/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const JobBaseUrl = baseDeployUrl + '/api/1.0/flow/job/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getGitJob = () => {
  return axios.request({
    url: JobBaseUrl + 'gitjob',
    headers: baseHeaders,
    method: 'get'
  })
}

export const getSvnJob = () => {
  return axios.request({
    url: JobBaseUrl + 'svnjob',
    headers: baseHeaders,
    method: 'get'
  })
}

export const getMemJob = () => {
  return axios.request({
    url: JobBaseUrl + 'member',
    headers: baseHeaders,
    method: 'get'
  })
}

export const getProjectJob = () => {
  return axios.request({
    url: JobBaseUrl + 'projectjob',
    headers: baseHeaders,
    method: 'get'
  })
}
